<ng-container *ngIf="menuEnabled">
<button mat-icon-button [matMenuTriggerFor]="notificationsMenu">
    <mat-icon [matBadge]="count" [matBadgeHidden]="count < 1" matBadgeOverlap="true" matBadgeColor="warn">
        notifications
    </mat-icon>
</button>
<mat-menu #notificationsMenu="matMenu" class="notification-center-menu">
    <div class="notification-center" (click)="$event.stopPropagation()">
        <div class="notification-header">
            <h4 class="notification-title">{{ '@notificationCenter' | translate }}</h4>
        </div>

        <div class="notification-actions">
            <button mat-button (click)="toggleHideSeen($event)">
                {{ (hideSeen ? '@viewAll' : '@hideAcknowledged') | translate }}
            </button>
            <span class="flex-spacer"></span>
            <button mat-button (click)="dismissAll()" [disabled]="disabled">
                {{ '@markAllAsRead' | translate }}
            </button>
        </div>

        <div class="notification-tabs">
            <button *ngFor="let tab of tabs"
                mat-button
                class="notification-tab"
                [class.selected]="selectedTabKey === tab.key"
                (click)="selectTab(tab.key)">
                {{ tab.labelKey | translate }}
                <span *ngIf="countForTab(tab.key) > 0" class="notification-tab-badge">{{ countForTab(tab.key) }}</span>
            </button>
        </div>

        <div class="notification-list">
            <div *ngFor="let notification of pagedNotifications"
                class="notification-item"
                (click)="navigate(notification)">
                <div class="notification-body">
                    <div class="notification-message">{{ notification.message }}</div>
                    <small class="notification-time">{{ notification.createDateTimeUtc | timeAgo }}</small>
                </div>
                <button mat-icon-button (click)="dismiss($event, notification)"
                    [title]="'@dismiss' | translate">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div *ngIf="pagedNotifications.length === 0" class="notification-empty">
                {{ '@noNewNotifications' | translate }}
            </div>
        </div>

        <div *ngIf="totalPages > 1" class="notification-pager">
            <button mat-icon-button (click)="prevPage()" [disabled]="pageIndex === 0">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <span>{{ pageIndex + 1 }} / {{ totalPages }}</span>
            <button mat-icon-button (click)="nextPage()" [disabled]="pageIndex >= totalPages - 1">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
    </div>
</mat-menu>
</ng-container>
